export default __webpack_public_path__ + "static/media/logo.11a61714.webp";